<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <table
      mat-table
      [dataSource]="inspection.riskLevels"
      class="mat-elevation-z4"
    >
      <ng-container matColumnDef="riskLevel">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.riskLevels:riskLevel') }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.level }}</td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.riskLevels:markCheck') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            color="primary"
            [(ngModel)]="element.selected"
            [disabled]="readonly || printPreview"
            (change)="onChange()"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="installationArea">
        <th mat-header-cell *matHeaderCellDef>
          {{ t('inspection.fields.riskLevels:installationAreas') }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field>
            <textarea
              matInput
              name="installationArea"
              cdkTextareaAutosize
              [drawableField]="
                (fieldSection || '') +
                ':' +
                (inspection?.title || '') +
                ':risk:' +
                element.level
              "
              [drawableFieldTitle]="
                t('inspection.fields.riskLevels:installationAreas') +
                ' - ' +
                element.level
              "
              [drawableFieldReadonly]="readonly"
              [(ngModel)]="element.installationArea"
              [readonly]="readonly || printPreview"
              [disabled]="!element.selected"
              (input)="onChange()"
            ></textarea>
            <div
              matSuffix
              class="note-btns"
              *ngIf="!(readonly || printPreview)"
            >
              <button
                mat-icon-button
                aria-label="notes-bank"
                color="primary"
                (click)="showNotesBank($event, element)"
              >
                <mat-icon>assignment</mat-icon>
              </button>
            </div>
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </authority-labs-check-case>
</ng-container>
